import * as _ from "lodash";
import * as log from "loglevel";
import * as marked from "marked";
import * as mobx from "mobx";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Accordion, Button, Checkbox, Dropdown, Form, Icon, List, Loader, Segment, SemanticICONS, Table } from "semantic-ui-react";

import { InfoCircle } from "../../components/info-circle";
import { config } from "../../config";
import { Agent } from "../../services/agent";
import { ActionStore } from "../../stores/action-store";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { App } from "../../stores/models/app";
import { AppAction } from "../../stores/models/app-action";
import { Project } from "../../stores/models/project";
import { ProjectMember } from "../../stores/models/project-member";
import { ProjectPermission } from "../../stores/models/project-permission";
import { User } from "../../stores/models/user";
import { ProjectAppStore } from "../../stores/project-app-store";
import { ProjectStore } from "../../stores/project-store";
import { UserStore } from "../../stores/user-store";
import { EditorPane } from "../common/editor-pane";
import { LoadingSpinner } from "../common/loading-spinner";
import { ProjectEditor } from "./project-editor";

declare var toastr: any;

interface IPermissionEditorProps {
	appStore?: AppStore;
	member: ProjectMember;
	project: Project;
	authStore?: AuthStore;
	actionStore?: ActionStore;
	projectAppStore?: ProjectAppStore;
	onMemberChanged();
}

interface IPermissionEditorState {
	errorMessage?: string;
	permissionViews?: PermissionView[];
	template?: any;
	loading: boolean;
}

@inject("appStore", "authStore", "actionStore", "projectAppStore") @observer
export class PermissionEditor extends React.Component<IPermissionEditorProps, IPermissionEditorState>
{
	constructor(props, state) {
		super(props, state);

		this.state = { "permissionViews": [], "loading": false };

		this.handleAppEnabledChange = this.handleAppEnabledChange.bind(this);
		this.handleActionChange = this.handleActionChange.bind(this);
	}

	async componentDidMount() {
		if (this.props.member) {
			await this.load(this.props);
		}
		if(this.props.projectAppStore && this.props.project) {
			await this.props.projectAppStore.loadProjectApps(this.props.project.id);
		}
	}

	async componentWillReceiveProps(nextProps: IPermissionEditorProps) {
		if (nextProps) {
			await this.load(nextProps);
		}
	}

	async load(props: IPermissionEditorProps) {
		try {
			if (props && props.member && props.project) {
				await props.member.loadPermissions();
				await Promise.all(props.member.permissions.map((p) => {
					return p.loadActions();
				}));
				let permissionViews: PermissionView[] = props.appStore.apps.filter((a) => !a.internal).map(a => {
					return new PermissionView(_.find(props.member.permissions, { "appId": a.id }), a, props.project.id);
				});

				this.setState({ "permissionViews": permissionViews });
			}
		} catch (err) {
			log.error(err);
			this.setState({ "errorMessage": err.message });
		}
	}

	async handleAppEnabledChange(pv: PermissionView) {
		try {
			pv.app.selected = !pv.app.selected;
			if (pv.app.selected) {
				let result = await Agent.ProjectMembers.addProjectPermission(this.props.member.id, pv.app.id);

				// if (this.props.authStore.user.accountType === 0) {
				// 	for (let i = 0; i < pv.app.actions.length; i++) {
				// 		await Agent.ProjectPermissions.addProjectPermissionAction(result.permissionId, pv.app.actions[i].id);
				// 	}
				// }
			}
			else {
				await this.props.member.removeProjectPermission(pv.app.id);
			}
			toastr.success("Change Saved");
			this.load(this.props);
		}
		catch (err) {
			log.error(err);
			this.setState({ "errorMessage": err.message });
		}
	}

	async handleActionChange(act: ActionView, pv: PermissionView) {
		try {
			act.selected = !act.selected;
			if (act.selected) {
				await pv.permission.addProjectPermissionAction(act.id);
			}
			else {
				await pv.permission.removeProjectPermissionAction(act.id);
			}
			toastr.success("Change Saved");
			this.load(this.props);
		}
		catch (err) {
			log.error(err);
			this.setState({ "errorMessage": err.message });
		}
	}


	handleTemplateSelectChange(templateId) {
		let templatePermissions = config.templatePermissions;

		this.setState({
			"template": templatePermissions[templateId]
		});
	}

	async applyTemplate() {
		await this.props.actionStore.loadActions(true, true);
		await this.props.appStore.loadApps(true, true);
		await this.load(this.props);

		this.setState({
			"loading": true
		});
		try {
			let template = this.state.template;
			console.log(this.state.permissionViews);
			let fullList: Array<App> = template.map((item) => {
				return { ...{ "fullAccess": item["fullAccess"], "allowedActions": item["actions"], "excludedActions": item["excludedActions"] }, ..._.find(this.state.permissionViews, { "app": { "id": item["id"] } }) };
			});
			for (let i = 0; i < fullList.length; i++) {
				let object = fullList[i];
				let app: AppView = object["app"];

				let permissionId = object["permission"] ? object["permission"].id : null;
				if (!app.selected) {
					let result = await Agent.ProjectMembers.addProjectPermission(this.props.member.id, app.id);
					permissionId = result.permissionId;
					// console.log(app, this.props.member.projectId);
				}

				let currentActions = app.actions;
				for (let i = 0; i < currentActions.length; i++) {
					let action: ActionView = currentActions[i];
					if (!action.selected 
							&& (object["fullAccess"] || object["allowedActions"].indexOf(action.name) != -1) 
							&& (!object["excludedActions"] || (Array.isArray(object["excludedActions"]) && object["excludedActions"].indexOf(action.name) === -1))
					) {
						// console.log(action);
						await Agent.ProjectPermissions.addProjectPermissionAction(permissionId, action.id);
					}
				}
			}

			toastr.success("Change Saved");
			this.load(this.props);
		}
		catch (err) {
			log.error(err);
			this.setState({ "errorMessage": err.message });
		}

		this.setState({
			"loading": false
		});
	}


	render() {
		const { appStore, member } = this.props;

		const templateOptions = [
			{
				"key": "3",
				"text": "Test Link Access",
				"value": "3"
			},
			{
				"key": "1",
				"text": "Full Client Access",
				"value": "1"
			},
			{
				"key": "2",
				"text": "Vendor Access",
				"value": "2"
			},
		];
		return (
			<>
				{
					this.props.authStore.user.accountType === 0 &&
					<Form>
						<Form.Group inline>
							<Form.Select compact label="Template" placeholder="Apply Template" options={templateOptions} onChange={(e, { value }) => this.handleTemplateSelectChange(value)} />
							<Button loading={this.state.loading} disabled={this.state.loading} color="orange" onClick={() => this.applyTemplate()} >Apply</Button>
						</Form.Group>
					</Form>
				}
				<Table celled className="permission-table">
					<Table.Body>
						{this.state.permissionViews.map((pv) => {
							let permissionDescription = "";
							let foundApp = _.find(appStore.apps, app => { return pv.app.id === app.id; });
							if (!_.isNil(foundApp) && !_.isNil(foundApp.permissionDescription)) {
								permissionDescription = foundApp.permissionDescription;
							}
							return (
								<Table.Row key={`${member.id}-${pv.app.id}`} error={_.findIndex(this.props.projectAppStore.projectApps, {"appId": pv.app.id}) == -1}>
									<Table.Cell>
										<Icon name={pv.app.icon as SemanticICONS} /><b>{pv.app.name}</b>
										{permissionDescription !== "" &&
											<InfoCircle header={pv.app.name}>
												<p dangerouslySetInnerHTML={{ "__html": marked(permissionDescription, { "sanitize": true }) }} />
											</InfoCircle>
										}
									</Table.Cell>
									<Table.Cell>
										<Button size="tiny" compact key={pv.app.id} active={pv.app.selected} toggle onClick={() => this.handleAppEnabledChange(pv)}>{pv.app.selected ? "enabled" : "disabled"}</Button>
									</Table.Cell>
									<Table.Cell>
										{pv.app.actions.map((act) => {
											return (
												<Button size="tiny" compact key={act.id} active={act.selected} disabled={!pv.app.selected} toggle onClick={() => this.handleActionChange(act, pv)}>{act.name}</Button>
											);
										})}
									</Table.Cell>
								</Table.Row>
							);
						})}
					</Table.Body>
				</Table>
			</>
		);
	}
}

class PermissionView {
	app: AppView;
	constructor(public permission: ProjectPermission, app: App, projectId: string) {
		this.app = new AppView(app, _.isNil(permission) ? null : permission.actions, projectId);
		this.app.selected = !_.isNil(permission);
	}
}

class AppView {
	selected: boolean = false;
	id: string;
	name: string;
	icon: string;
	actions: ActionView[] = [];

	constructor(app: App, permissionActions: AppAction[], projectId: string) {
		this.id = app.id;
		this.name = app.name;
		this.icon = app.icon;

		if (app.actions) {
			this.actions = app.actions.filter(a => a.projectId == null || a.projectId == projectId).map(act => {
				let av = new ActionView(act);
				if (permissionActions) {
					//log.debug(permissionActions.slice(), av);
					av.selected = _.findIndex(permissionActions, { "id": act.id }) > -1;
				}
				return av;
			});
		}
	}
}

class ActionView {
	selected: boolean = false;
	id: string;
	name: string;

	constructor(action: AppAction) {
		this.id = action.id;
		this.name = action.name;
	}
}



// WEBPACK FOOTER //
// ./src/views/projects/permission-editor.tsx